import NativeSelect from '../../utils/NativeSelect'
export default {
    components: {
        NativeSelect
    },
    mounted() {
        this.getAllGraduationPeriods()
    },
    data: () => ({
        GRADUATION_PERIOD_ID_PK: 1,
        GRADUATION_PERIODS: []
    }),
    methods: {
        getAllGraduationPeriods() {
            var self = this
            this.$ajax.get("/GRADUATION_PERIOD/GetAllListAsync").then(response => {
                self.GRADUATION_PERIODS = response.data
                self.$ajax.get("/GRADUATION_PERIOD/GetActivePeriodAsync").then(response => {
                    self.GRADUATION_PERIOD_ID_PK = response.data.GRADUATION_PERIOD_ID_PK
                }).catch(reponse => {
                    self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
                })
            }).catch(reponse => {
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        },
        updateGraduationPeriod() {
            var self = this
            self.$root.$confirm('Confirme', 'Por favor confirme la acción solicitada. ¿Seguro que quieres hacer esto?')
                .then(result => {
                    if (result) {
                        self.$ajax.post("/GRADUATION_PERIOD/Update", {
                            GRADUATION_PERIOD_ID_PK: self.GRADUATION_PERIOD_ID_PK
                        }).then(response => {
                            self.$root.$snackbar("Los datos fueron guardados correctamente.", { color: 'success' })
                        }).catch(reponse => {
                            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de guardar los datos.', { color: 'error' })
                        })
                    }
                })
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/graduados/periodoGraduacion/script.js